/**
 * @generated SignedSource<<7c30b53678defea7d4e443ba5ae40a20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type RewardsQuery$variables = {};
export type RewardsQuery$data = {
  readonly redemptionTypes: {
    readonly types: ReadonlyArray<{
      readonly id: string;
      readonly name: RedemptionTypeKey;
    }>;
  } | null;
  readonly targetRedemptionValue: {
    readonly " $fragmentSpreads": FragmentRefs<"UserBalance_target">;
  } | null;
  readonly walletBalance: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CurrentEarningsCard_currentEarnings">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TransactionHistoryFragment">;
};
export type RewardsQuery = {
  response: RewardsQuery$data;
  variables: RewardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "RedemptionType",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subUnitAmount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TransactionHistoryFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CurrentEarningsCard_currentEarnings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBalance_target"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RewardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WalletTransactionConnection",
        "kind": "LinkedField",
        "name": "walletTransactions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletTransactionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WalletTransaction",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "amount",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "walletTransactions(first:20)"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "TransactionHistoryFragment_walletTransactions",
        "kind": "LinkedHandle",
        "name": "walletTransactions"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "panelistCost",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "redemptionAmount",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02a21d2eda03d572273ce837e080805d",
    "id": null,
    "metadata": {},
    "name": "RewardsQuery",
    "operationKind": "query",
    "text": "query RewardsQuery {\n  ...TransactionHistoryFragment\n  walletBalance {\n    id\n    ...CurrentEarningsCard_currentEarnings\n  }\n  targetRedemptionValue {\n    ...UserBalance_target\n  }\n  redemptionTypes {\n    types {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment CurrentEarningsCard_currentEarnings on WalletBalance {\n  amount {\n    subUnitAmount\n  }\n  id\n}\n\nfragment TransactionHistoryFragment on Query {\n  walletTransactions(first: 20) {\n    edges {\n      node {\n        id\n        amount {\n          formatted\n        }\n        createdAt\n        eventType\n        sourceType\n        description\n        supportId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n\nfragment UserBalance_target on AmountDenomination {\n  panelistCost {\n    subUnitAmount\n  }\n  redemptionAmount {\n    formatted\n  }\n}\n"
  }
};
})();

(node as any).hash = "569fbe256dbee59fcd410057a8e7a22e";

export default node;
